function getApiURL() {
	let { hostname, protocol } = document.location;
	let splits = hostname.split('.');
	splits.unshift('api')
	let apiUrl = protocol + '//' + splits.join('.') + '/';
	return apiUrl;
	// return 'http://api2.zeoan.in:8000/'
}
export const settingsConfig = { api_url: getApiURL() };
